import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, HandHeart, MessageCircle, Star, CheckCheck, Activity, UserPlus } from "lucide-react";
import { api } from "@/lib/api";
import { timeAgo } from "@/components/PostCard";

const ICON = { connect: HandHeart, message: MessageCircle, review: Star, status: Activity, invite: UserPlus };

export default function Notifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  const load = async () => { const { data } = await api.get("/notifications"); setItems(data.items); };
  useEffect(() => { load(); }, []);

  const open = async (n) => {
    if (!n.read) { await api.post(`/notifications/${n.notification_id}/read`); }
    navigate(n.link || "/app");
  };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <h1 className="font-head text-3xl sm:text-4xl font-bold text-forest-900">Alerts</h1>
        <button onClick={markAll} data-testid="mark-all-read"
          className="ml-auto flex items-center gap-2 text-forest-700 font-semibold hover:text-terracotta transition-colors">
          <CheckCheck size={20} strokeWidth={2.5} /> Mark all read
        </button>
      </div>
      {items === null ? (
        <div className="space-y-3">{[0, 1, 2].map((i) => <div key={i} className="h-20 rounded-2xl bg-white/60 border-2 border-border animate-pulse" />)}</div>
      ) : items.length === 0 ? (
        <div className="bg-white rounded-2xl border-2 border-border p-12 text-center">
          <Bell size={48} className="mx-auto text-forest-500 mb-4" strokeWidth={2} />
          <p className="text-forest-700 text-lg">You're all caught up.</p>
        </div>
      ) : (
        <div className="space-y-3" data-testid="notif-list">
          {items.map((n) => {
            const Icon = ICON[n.type] || Bell;
            return (
              <button key={n.notification_id} onClick={() => open(n)} data-testid={`notif-${n.notification_id}`}
                className={`w-full flex items-center gap-4 p-4 rounded-2xl border-2 text-left transition-colors ${n.read ? "bg-white border-border" : "bg-gold-light border-gold"}`}>
                <div className="w-12 h-12 rounded-full bg-cream border-2 border-border flex items-center justify-center shrink-0">
                  <Icon size={22} strokeWidth={2.5} className="text-terracotta" />
                </div>
                <div className="min-w-0">
                  <p className="text-forest-900 font-medium leading-snug">{n.text}</p>
                  <p className="text-sm text-forest-500 mt-0.5">{timeAgo(n.created_at)}</p>
                </div>
                {!n.read && <span className="ml-auto w-3 h-3 rounded-full bg-terracotta shrink-0" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
